export default "__VITE_ASSET__3f0d51bf__"